import { httpsCallable } from "firebase/functions";
import { functions, db } from "../firebase";
import { collection, doc, getDocs, getDoc, addDoc, deleteDoc, updateDoc, query, orderBy, where, Timestamp } from "firebase/firestore";


const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
export const get = async (endpoint) => {
  const token = localStorage.getItem('token');
  
    const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
  
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
  
    return response.json();
};

export const getAvailableTimeSlots = async (date) => {
  const dateString = date.toISOString().split("T")[0];
  try {
    const querySnapshot = await getDocs(collection(db, "availableSlots"));
    const slots = querySnapshot.docs
      .filter(
        (doc) => doc.data().date.toDate().toISOString().split("T")[0] === dateString
      )
      .map((doc) => ({ id: doc.id, ...doc.data() }))[0];
    return slots;
  } catch (error) {
    console.error("Error fetching available time slots:", error);
    throw error;
  }
};


function generateRandomPin(length = 4) {
  const characters = '0123456789';
  let pin = '';
  for (let i = 0; i < length; i++) {
    pin += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return pin;
}

export const createReservation = async (userId, date, startTime, endTime) => {
  try {
    const reservationsCollection = collection(db, "reservations");
    const pin = generateRandomPin()
    const newReservation = {
      userId,
      date,
      startTime,
      endTime,
      pin,
      createdAt: new Date(),
    };
    const docRef = await addDoc(reservationsCollection, newReservation);
    console.log("Document written with ID: ", docRef.id);
    return docRef.id;
  } catch (error) {
    console.error("Error creating reservation:", error);
    throw error;
  }
};

export const deleteReservation = async (reservationId) => {
    try {
      await deleteDoc(doc(db, "reservations", reservationId));
    } catch (error) {
      console.error("Error deleting reservation:", error);
      throw error;
    }
  };

export const addAvailableTimeSlot = async (date, startTime, endTime) => {
  try {
    const availableSlotsCollection = collection(db, "availableSlots");
    const dateString = date.toISOString().split("T")[0];
    const querySnapshot = await getDocs(availableSlotsCollection);
    
    let docId = null;
    let existingSlots = [];
    
    querySnapshot.forEach((doc) => {
      const docDate = doc.data().date.toDate().toISOString().split("T")[0];
      if (docDate === dateString) {
        docId = doc.id;
        existingSlots = doc.data().slots || [];
      }
    });

    const newSlot = { startTime, endTime };
    
    const slotExists = existingSlots.some(
      (slot) =>
        (slot.startTime === startTime && slot.endTime === endTime) || // Tamamen aynı slot var mı?
        (startTime < slot.endTime && startTime >= slot.startTime) || // Yeni başlangıç var olan aralık içinde mi?
        (endTime > slot.startTime && endTime <= slot.endTime) ||  // Yeni bitiş var olan aralık içinde mi?
        (startTime <= slot.startTime && endTime >= slot.endTime) // Yeni slot var olan slotu kapsıyor mu?
    );

    if (slotExists) {
      throw new Error("Bu zaman aralığı zaten mevcut veya çakışan bir aralık var.");
    }
    
    if (docId) {
      await updateDoc(doc(db, "availableSlots", docId), {
        slots: [...existingSlots, newSlot],
      });
    } else {
      await addDoc(availableSlotsCollection, { date, slots: [newSlot] });
    }
  } catch (error) {
    console.error("Error adding available time slot:", error);
    throw error;
    }
  };
  
// ==================== SEAM BOOKING API ====================
const createBookingCallable = httpsCallable(functions, 'createBooking');
const cancelBookingCallable = httpsCallable(functions, 'cancelBooking');
const listSeamDevicesCallable = httpsCallable(functions, 'listSeamDevices');

// Rezervasyon oluştur (SEAM ile kapı kodu alır)
export const createBooking = async (data) => {
    try {
        const result = await createBookingCallable(data);
        return result.data;
    } catch (error) {
        throw error;
    }
};

// Rezervasyonu iptal et (SEAM kapı kodunu da siler)
export const cancelBooking = async (reservationId) => {
    try {
        const result = await cancelBookingCallable({ reservationId });
        return result.data;
    } catch (error) {
        throw error;
    }
};

// NOT: getAccessCode kaldırıldı - PIN bilgisi artık Firestore'dan okunuyor
// Rezervasyon belgesi şu alanları içerir: pin, pinStatus, pinStartsAt, pinEndsAt

// SEAM cihazlarını listele (admin için)
export const listSeamDevices = async () => {
    try {
        const result = await listSeamDevicesCallable();
        return result.data;
    } catch (error) {
        throw error;
    }
};

export const post = async (endpoint, data) => {
    const token = localStorage.getItem('token');

    const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    return response.json();
};

// ==================== EVENTS API ====================

// Tüm etkinlikleri getir
export const getEvents = async () => {
  try {
    const eventsCollection = collection(db, "events");
    const q = query(eventsCollection, orderBy("date", "asc"));
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      date: doc.data().date?.toDate ? doc.data().date.toDate() : doc.data().date,
    }));
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};

// Tek bir etkinlik getir
export const getEventById = async (eventId) => {
  try {
    const eventDoc = await getDoc(doc(db, "events", eventId));
    if (eventDoc.exists()) {
      const data = eventDoc.data();
      return {
        id: eventDoc.id,
        ...data,
        date: data.date?.toDate ? data.date.toDate() : data.date,
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching event:", error);
    throw error;
  }
};

// Öne çıkan etkinlikleri getir
export const getFeaturedEvents = async (limit = 3) => {
  try {
    const eventsCollection = collection(db, "events");
    const q = query(
      eventsCollection,
      where("featured", "==", true),
      orderBy("date", "asc")
    );
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.slice(0, limit).map((doc) => ({
      id: doc.id,
      ...doc.data(),
      date: doc.data().date?.toDate ? doc.data().date.toDate() : doc.data().date,
    }));
  } catch (error) {
    console.error("Error fetching featured events:", error);
    throw error;
  }
};

// Yeni etkinlik oluştur
export const createEvent = async (eventData) => {
  try {
    const eventsCollection = collection(db, "events");
    const newEvent = {
      ...eventData,
      date: eventData.date instanceof Date ? Timestamp.fromDate(eventData.date) : eventData.date,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    };
    const docRef = await addDoc(eventsCollection, newEvent);
    return { id: docRef.id, ...eventData };
  } catch (error) {
    console.error("Error creating event:", error);
    throw error;
  }
};

// Etkinlik güncelle
export const updateEvent = async (eventId, eventData) => {
  try {
    const eventRef = doc(db, "events", eventId);
    const updatedEvent = {
      ...eventData,
      date: eventData.date instanceof Date ? Timestamp.fromDate(eventData.date) : eventData.date,
      updatedAt: Timestamp.now(),
    };
    await updateDoc(eventRef, updatedEvent);
    return { id: eventId, ...eventData };
  } catch (error) {
    console.error("Error updating event:", error);
    throw error;
  }
};

// Etkinlik sil
export const deleteEvent = async (eventId) => {
  try {
    await deleteDoc(doc(db, "events", eventId));
    return true;
  } catch (error) {
    console.error("Error deleting event:", error);
    throw error;
  }
};

// Kategoriye göre etkinlikleri getir
export const getEventsByCategory = async (category) => {
  try {
    const eventsCollection = collection(db, "events");
    const q = query(
      eventsCollection,
      where("category", "==", category),
      orderBy("date", "asc")
    );
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      date: doc.data().date?.toDate ? doc.data().date.toDate() : doc.data().date,
    }));
  } catch (error) {
    console.error("Error fetching events by category:", error);
    throw error;
  }
};

// Haftalık program yönetimi
const getWeeklyScheduleCallable = httpsCallable(functions, "getWeeklySchedule");
const setWeeklyScheduleCallable = httpsCallable(functions, "setWeeklySchedule");

export const getWeeklySchedule = async () => {
  try {
    const result = await getWeeklyScheduleCallable();
    return result.data.schedule;
  } catch (error) {
    console.error("Error fetching weekly schedule:", error);
    throw error;
  }
};

export const setWeeklySchedule = async (schedule) => {
  try {
    const result = await setWeeklyScheduleCallable({ schedule });
    return result.data;
  } catch (error) {
    console.error("Error setting weekly schedule:", error);
    throw error;
  }
};

// Kullanıcı yönetimi
const getAllUsersCallable = httpsCallable(functions, "getAllUsers");
const updateUserRoleCallable = httpsCallable(functions, "updateUserRole");
const blockUserCallable = httpsCallable(functions, "blockUser");
const unblockUserCallable = httpsCallable(functions, "unblockUser");

export const getAllUsers = async () => {
  try {
    const result = await getAllUsersCallable();
    return result.data.users || [];
  } catch (error) {
    console.error("Error getting all users:", error);
    throw error;
  }
};

export const updateUserRole = async (targetUserId, makeAdmin) => {
  try {
    const result = await updateUserRoleCallable({ targetUserId, makeAdmin });
    return result.data;
  } catch (error) {
    console.error("Error updating user role:", error);
    throw error;
  }
};

export const blockUser = async (userId, reason = "") => {
  try {
    const result = await blockUserCallable({ userId, reason });
    return result.data;
  } catch (error) {
    console.error("Error blocking user:", error);
    throw error;
  }
};

export const unblockUser = async (userId) => {
  try {
    const result = await unblockUserCallable({ userId });
    return result.data;
  } catch (error) {
    console.error("Error unblocking user:", error);
    throw error;
  }
};


